import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute, redirect } from '@tanstack/react-router';

/** The section has no landing page of its own: open on the client database. */
export const Route = createFileRoute('/console/$orgId/configuration/fleet/')({
    beforeLoad: ({ params }): ShareableRouteContext => {
        throw redirect({ to: '/console/$orgId/configuration/fleet/client-database', params, replace: true });
    },
});
